import Image from 'next/image';
import React, { useState } from 'react';
import { ConsultDoctorContainer, ConsultSection } from './styled';
import { images } from '../../../Constants/ImageUrls';
import BookingDone from './BookingDone';
import { useRouter } from 'next/router';
import { formFetcher } from '../../../datafetchers/IVFPage';
import { fireClickedCta, firePopupEvents } from './instrumentation';
import ConsultPopup from './ConsultPopup';

const ConsultDoctor = (props) => {
  const { productData, isFertilityProduct } = props;
  const [clickEffect, setClickEffect] = useState('');
  const [showConsultPopup, setShowConsultPopup] = useState(false);
  const [bookingDone, setBookingDone] = useState(false);
  const [bookingDoneData, setBookingDoneData] = useState({});
  const [formData, setFormData] = useState();
  const router = useRouter();
  const fetchForm = async () => {
    const splitUrl = productData?.form_url?.split('/');
    const formId = splitUrl[splitUrl?.length - 1];
    const formData = await formFetcher({}, formId);
    setFormData(formData?.data);
  };

  const consultHandler = async () => {
    fireClickedCta('chat with us', productData);
    setClickEffect('lowOpacity');
    firePopupEvents('viewed_popup');
    await fetchForm();
    const params = new URLSearchParams(window.location.search);
    params.set('consult', 'true');
    router.push(window?.location?.pathname + '?' + params, undefined, {
      shallow: true,
      scroll: false,
    });
    setTimeout(() => {
      setClickEffect('');
    }, 200);
  };
  const whatsappConsultHandler = () => {
    fireClickedCta('chat with us', productData);
    setClickEffect('lowOpacity');
    const whatsappMessage =
      'Hi, I have a query regarding Ovaluna Female Fertility Supplement!';
    const params = new URLSearchParams(window.location.search);
    router.push(
      `https://wa.me/+918800514482?text=${whatsappMessage}` + '&' + params,
      undefined,
      {
        shallow: true,
        scroll: false,
      },
    );
    setTimeout(() => {
      setClickEffect('');
    }, 200);
  };
  return (
    <>
      <ConsultPopup
        showConsultPopup={showConsultPopup}
        setShowConsultPopup={setShowConsultPopup}
        setBookingDone={setBookingDone}
        productData={productData}
        formData={formData}
        bookingDoneData={bookingDoneData}
        setBookingDoneData={setBookingDoneData}
      />
      <ConsultDoctorContainer isFertilityProduct={isFertilityProduct}>
        {!bookingDone ? (
          <ConsultSection isFertilityProduct={isFertilityProduct}>
            <div className="consultRight">
              {isFertilityProduct ? (
                <h2>Still Having doubts on Ovaluna?</h2>
              ) : (
                <h2>Not sure if this is right for you?</h2>
              )}

              {!isFertilityProduct ? (
                <p className="consultText">
                  Our Experts are here to help you figure it out.
                </p>
              ) : (
                <p className="consultText">
                  Send us your questions, and our fertility expert will respond
                  promptly!
                </p>
              )}
              {!isFertilityProduct && (
                <span className="noCharge">
                  Personalised Help. Stay anonymous.
                </span>
              )}
              <button
                onClick={
                  isFertilityProduct ? whatsappConsultHandler : consultHandler
                }
                className={`${clickEffect} pdpButton`}
              >
                {isFertilityProduct && (
                  <img
                    src={images.newwhatsappWhite}
                    alt=""
                    className="whatsappIcon"
                  />
                )}
                <p>
                  {isFertilityProduct ? 'Chat with Us Now' : 'Chat with us'}
                </p>
                <img src={images.arrow_white} alt="" className="arrowSvg" />
                <span></span>
              </button>
            </div>
            <div className="pdpDoctorImg">
              <Image
                src={
                  isFertilityProduct
                    ? 'https://images.myloapp.in/NestJsUploads/animated_webp/1725531616645-lead-form-gif.webp'
                    : images.doctor_image_pdp
                }
                quality={90}
                alt=""
                fill
                sizes="33vw"
              />
            </div>
          </ConsultSection>
        ) : (
          <BookingDone bookingDoneData={bookingDoneData} />
        )}
      </ConsultDoctorContainer>
    </>
  );
};

export default ConsultDoctor;
